import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { API_BASE_URL } from "../Config/Config";
import CommonFooter from "../../../core/common/footer/commonFooter";
import { Spin } from "antd";

const QueryExecute = () => {
  const { state } = useLocation();
  const record = state?.record;

  const [executeForm, setExecuteForm] = useState({
    predefinedQuery: record?.Name || "",
    database: record?.Database || "",
    query: record?.SqlQuery || "",
  });
  const [queryResult, setQueryResult] = useState([]);
  const [showResult, setShowResult] = useState(false);
  const [addLoading, setAddLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

  const currentRecords = queryResult.slice(
    indexOfFirstRecord,
    indexOfLastRecord,
  );

  const totalPages = Math.ceil(queryResult.length / recordsPerPage);

  const executeQueryApi = async () => {
    setAddLoading(true);
    try {
      const payload = {
        Database: String(executeForm.database),
        query: String(executeForm.query),
      };

      const response = await fetch(`${API_BASE_URL}/api/excuteqery`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data?.success === true) {
        setQueryResult(data?.data || []);
        setShowResult(true);
        setCurrentPage(1); // reset pagination
      } else {
        Swal.fire("Error", data?.ResultMessage, "error");
        setShowResult(false);
      }
    } catch (error) {
      Swal.fire("Error", "Something went wrong", "error");
      setShowResult(false);
    }
    setAddLoading(false);
  };

  return (
    <>
      {addLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(255,255,255,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <Spin size="large" />
        </div>
      )}
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Query Execution</h4>
                <h6>Manage your Database QueryExecution</h6>
              </div>
            </div>
          </div>
          <div className="accordion" id="executeAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#executeQueryCollapse"
                >
                  Query Execution Panel
                </button>
              </h2>

              <div
                id="executeQueryCollapse"
                className="accordion-collapse collapse show"
              >
                <div className="accordion-body">
                  <div className="row">
                    {/* Predefined Query */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Query Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={executeForm.predefinedQuery}
                        disabled
                      />
                    </div>

                    {/* Database */}
                    <div className="col-md-6 mb-3">
                      <label className="form-label">Database</label>
                      <input
                        type="text"
                        className="form-control"
                        value={executeForm.database}
                        disabled
                      />
                    </div>

                    {/* Editable Query */}
                    <div className="col-md-12 mb-3">
                      <label className="form-label">Query</label>
                      <textarea
                        className="form-control"
                        rows="4"
                        value={executeForm.query}
                        onChange={(e) =>
                          setExecuteForm({
                            ...executeForm,
                            query: e.target.value,
                          })
                        }
                      />
                    </div>

                    {/* Execute Button */}
                    <div className="col-md-12 text-end">
                      <button
                        className="btn btn-primary"
                        onClick={executeQueryApi}
                      >
                        Execute Query
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {showResult && queryResult.length === 0 && (
            <div className="alert alert-warning mt-4">
              Query executed successfully but returned no records.
            </div>
          )}

          {showResult && queryResult.length > 0 && (
            <div className="card mt-4">
              <div className="card-header">
                <h5 className="mb-0">Query Result</h5>
              </div>

              <div className="card-body table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      {Object.keys(queryResult[0]).map((key) => (
                        <th key={key}>{key}</th>
                      ))}
                    </tr>
                  </thead>

                  <tbody>
                    {currentRecords.map((row, index) => (
                      <tr key={index}>
                        {Object.values(row).map((value, i) => (
                          <td key={i}>{String(value)}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
                {totalPages > 1 && (
                  <nav className="mt-3">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>

                      {[...Array(totalPages)].map((_, index) => (
                        <li
                          key={index}
                          className={`page-item ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => setCurrentPage(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}

                      <li
                        className={`page-item ${
                          currentPage === totalPages ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => setCurrentPage(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                )}
              </div>
            </div>
          )}
        </div>
        <CommonFooter />
      </div>
    </>
  );
};
export default QueryExecute;
